import * as Mutations from '../../mutations';

export default {
  [Mutations.SET_INSTALLATION](store, installation) {
    store.installation = installation;
  },
  [Mutations.SET_USER_ACCESSIBLE_INSTALLATION](store, installations) {
    store.userAccessibleInstallations = installations;
  },
  [Mutations.SET_SIMULATION_DATA_POINTS](store, points) {
    store.simulationData.points = points;
  },
  [Mutations.SET_SIMULATION_DATA_IS_INVALID](store, isInvalid) {
    store.simulationData.isInvalid = isInvalid;
  },
  [Mutations.SET_SIMULATION_DATA_VALID_POINTS](store, validPoints) {
    store.simulationData.validPoints = validPoints;
  },
  [Mutations.SET_SIMULATION_DATA_IS_EMPTY](store, isEmpty) {
    store.simulationData.isEmpty = isEmpty;
  },
  [Mutations.SET_SIMULATION_DATA_INTERVAL](store, interval) {
    store.simulationData.interval = interval;
  },
  [Mutations.SET_SIMULATION_DATA_IS_INTERVAL_INVALID](store, isIntervalInvalid) {
    store.simulationData.isIntervalInvalid = isIntervalInvalid;
  },
  [Mutations.SET_SIMULATION_DATA_REPETITIONS](store, repetitions) {
    store.simulationData.repetitions = repetitions;
  },
  [Mutations.SET_SIMULATION_DATA_IS_REPETITIONS_INVALID](store, isRepetitionsInvalid) {
    store.simulationData.isRepetitionsInvalid = isRepetitionsInvalid;
  },
  [Mutations.SET_SIMULATION_DATA_IMPORT_DATA](store, importData) {
    store.simulationData.importData = importData;
  },
};
